import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faLinkHorizontal } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'src/components/PulseUI';

interface StrategyEngageBadgeProps {
  /**
   * Optional additional CSS classes to apply to the badge container
   */
  className?: string;
}

/**
 * StrategyEngageBadge Component
 *
 * Displays a badge with a horizontal link icon to indicate that a strategy
 * has associated engage/expand strategies. The badge includes a tooltip
 * that appears on hover.
 *
 * @param {StrategyEngageBadgeProps} props - Component props
 * @returns {React.ReactElement} The rendered badge component
 *
 * @example
 * ```tsx
 * // Basic usage
 * <StrategyEngageBadge />
 *
 * // With custom className
 * <StrategyEngageBadge className="ml-2" />
 * ```
 */
const StrategyEngageBadge: React.FC<StrategyEngageBadgeProps> = ({
  className = '',
}): React.ReactElement => {
  return (
    <Tooltip content="Has Engage/Expand Strategy" position="top">
      <div
        className={`h-6 px-1.5 py-1 rounded-md border border-neutral-400 inline-flex justify-center 
            items-center gap-0.5 overflow-hidden ${className}`}
      >
        <div className="w-3 h-3 flex items-center justify-center">
          <Icon icon={faLinkHorizontal} size="xs" className="text-secondary" />
        </div>
      </div>
    </Tooltip>
  );
};

export default StrategyEngageBadge;
